import { Injectable } from '@angular/core';
import { CookieStorage } from '@kimaya/ngx-cookie-storage';
import { Router } from '@angular/router';
import { CoreConstants, PREFERENCE_TYPE } from '../core.constants';
import { HttpService, HttpServiceConstants } from '@kimaya/ngx-http-service';
import { environment } from '../../../environments/environment';
import { GetOrganisationByAlias } from '../types';
import { AuthService, AuthServiceConstants } from '@kimaya/ngx-auth-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoaderService } from '@kimaya/ngx-base-common-hive';
// To fix Circular Dependency Warning
// To fix Circular Dependency Warning
import { UserDetailsResponse } from '../../modules/auth/types';
import { TreoNavigationService } from '../../../@treo/components/navigation';
import { SnackBarService, UserProfilePojo, UserService } from '..';
import { DefaultNavigationList, InternalNavigationList } from '../../navigations';
import { WebSocketConfigService } from '../web-socket/web-socket-config.service';
import { LodashReplacements } from 'app/core/utils/lodash-replacements';
const { cloneDeep } = LodashReplacements;

export const COOKIES = {
  organization: 'hitechOrgId',
  preference: 'preference',
};

export const HEADERS = {
  organization: 'organisationId',
};

export const sendMessage = '/send/message';

@Injectable({
  providedIn: 'root',
})
export class OrganisationService {

  public observer: BehaviorSubject<any> = new BehaviorSubject<any>('');
  public _workspceId: string;
  public defaultWorkspaceId: string;

  constructor(private cookieStorage: CookieStorage, private router: Router,
              private loaderService: LoaderService,
              private httpService: HttpService, private authService: AuthService,
              private userService: UserService,
              private navigationService: TreoNavigationService,
              private snackBarService: SnackBarService, private webSocketConfigService: WebSocketConfigService) {
  }

  public _orgObserver$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  get orgObserver$(): BehaviorSubject<any> {
    return this._orgObserver$;
  }

  public _workObserver$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  get workObserver$(): BehaviorSubject<any> {
    return this._workObserver$;
  }

  private _subDomain: string;

  get subDomain(): string {
    return this._subDomain;
  }

  set subDomain(value: string) {
    this._subDomain = value;
  }

  private _organisationId: string;

  get organisationId(): string {
    return this._organisationId;
  }

  set organisationId(value: string) {
    if (value) {
      this.setHeaders(value);
      if (!this.subDomain) {
        this.setOrganisationIdToCookie(value);
      }
      this._organisationId = value;
      this._orgObserver$.next(value);
    } else {
      this._organisationId = null;
      this.removeHeaders();
    }
  }

  public isInvalidSubDomain(): boolean {
    return !!(!this.subDomain && !this.organisationId);
    // return !(util(this.subDomain).isEmpty() && util(this.organisationId).isEmpty());
  }

  public setupSubDomain(): void {
    if (this.getSubDomainFromUrl()) {
      this.getOrganisationUsingAliasFromServer(this.getSubDomainFromUrl());
    } else if (this.getOrganisationIdFromCookie()) {
      this.organisationId = this.getOrganisationIdFromCookie();
      if (!this.organisationId && this.authService.isLoggedIn()) {
        this.redirectToSelectOrganisation();
      }
      this.observer.next('');
    }
  }

  redirectToSelectOrganisation(): void {
    this.router.navigate(['/auth/organisations']);
  }

  public setOrganisationIdToCookie(organisationId: string): void {
    this.cookieStorage.set(COOKIES.organization, organisationId);
    this.setHeaders(organisationId);
    this.observer.next('');
  }

  public removeOrganisationId(): void {
    this.cookieStorage.delete(COOKIES.organization);
    this.organisationId = null;
    this.removeHeaders();
    this._orgObserver$.next(null);
    this.observer.next('');
  }

  public getOrganizationRoles(): Observable<any> {
    this.loaderService.show();
    return new Observable<UserDetailsResponse>((resolver: any): any => {
      this.httpService.get(CoreConstants.API.getOrgRoles)
        .subscribe((response: UserDetailsResponse) => {
          this.loaderService.hide();
          // .subscribe((userDetails: UserDetailsResponse) => {
          if (response.code === 200) {
            resolver.next(response);
            resolver.complete();
          } else {
            resolver.error(response);
          }
        }, (error) => {
          resolver.error(error);
        });
    });
  }

  public getOrganisationIdFromCookie(): string {
    return this.cookieStorage.get(COOKIES.organization);
  }

  setUserDetailsAndNavigate(userDetails: UserProfilePojo): void {
    if (!userDetails.organisations) {
      userDetails.organisations = [];
    }
    if (!userDetails.appRoles) {
      userDetails.appRoles = [];
    }
    if (!userDetails.orgRoles) {
      userDetails.orgRoles = [];
    }
    this.initUserData(userDetails);
  }


  initUserData(userDetails: UserProfilePojo): void {
    this.userService.setUser(userDetails, true);
    this.webSocketConfigService.connect(() => {
      if (this.subDomain) {
        this.setNavigation();
        this.setLoginAndRedirect();
      } else if (userDetails.organisations && userDetails.organisations.length > 0) {
        if (userDetails.organisations.length === 1 && userDetails.appRoles.length === 0) {
          this.organisationId = userDetails.organisations[0].id;
          this.onSelectOrganisation(userDetails.organisations[0].id);
        } else {
          this.cookieStorage.set(COOKIES.preference, PREFERENCE_TYPE.org);
          this.authService.setUserLoggedIn();
          this.navigateUser(userDetails);
        }
      } else {
        this.cookieStorage.set(COOKIES.preference, PREFERENCE_TYPE.internal);
        this.authService.setUserLoggedIn();
        this.navigateUser(userDetails);
      }
    });

  }

  onSelectOrganisation(orgId: string): void {
    this.organisationId = orgId;
    this.cookieStorage.set(COOKIES.preference, PREFERENCE_TYPE.org);
    this.getOrganizationRoles()
      .subscribe((response: any) => {
        if (response) {
          this.userService.setUser(response.userDetails, true, true);
          this.setNavigation();
          this.setLoginAndRedirect();
        } else {
          this.logout();
        }
      });
  }

  setNavigation(internal = false): void {
    if (internal) {
      this.navigationService.deleteNavigation('main');
      this.navigationService.deleteNavigation('admin');
      this.navigationService.storeNavigation('admin', cloneDeep(InternalNavigationList));
    } else {
      this.navigationService.deleteNavigation('main');
      this.navigationService.deleteNavigation('admin');
      this.navigationService.storeNavigation('main', cloneDeep(DefaultNavigationList));
    }

  }

  public showOrganizationBlockToaster(): void {
    this.snackBarService.open('Your organization has been deactivated, please contact system administrator', 'error');
  }

  logout(): void {
    this.authService.logoutSystem().subscribe((response) => {
      this.userService.resetUser();
      // this.navigationService.resetNavigation();
      this.authService.removeUsersDetailsAndRedirect();
      this.removeOrganisationId();
    }, () => {
      this.userService.resetUser();
      // this.navigationService.resetNavigation();
      this.authService.removeUsersDetailsAndRedirect();
      this.removeOrganisationId();
    });
  }

  private navigateUser(userDetails): void {
    this.setNavigation(true);
    this.router.navigate([CoreConstants.firstPage]);
  }

  private setLoginAndRedirect(): void {
    this.authService.setUserLoggedIn();
    this.router.navigate([CoreConstants.firstPage]);
  }

  private setHeaders(value: string, key = HEADERS.organization): void {
    if (value) {
      if (HttpServiceConstants.headers) {
        HttpServiceConstants.headers[key] = value;
      }
      if (AuthServiceConstants.headers) {
        AuthServiceConstants.headers[key] = value;
      }
    } else {
      delete AuthServiceConstants.headers[key];
    }
  }

  private removeHeaders(): void {
    if (HttpServiceConstants.headers) {
      delete HttpServiceConstants.headers[HEADERS.organization];
    }
    if (AuthServiceConstants.headers) {
      delete AuthServiceConstants.headers[HEADERS.organization];
    }
  }

  private getOrganisationUsingAliasFromServer(subDomain: string): void {
    this.httpService.get(CoreConstants.API.getOrgByAlias + subDomain).subscribe((response: GetOrganisationByAlias) => {
      if (response.code === 200 && response.organisation && response.organisation.id) {
        this.subDomain = response.organisation.alias;
        this.organisationId = response.organisation.id;
      }
      this.observer.next('');
    }, () => {
      this.observer.next('');
    });
  }

  private getSubDomainFromUrl(): string {
    const domain = window.location.hostname;
    if (environment.production) {
      if (domain.indexOf('.') < 0 || domain.split('.')[0] === 'www' ||
        CoreConstants.excludeDomainUrl.includes(domain.split('.')[0])) {
        return null;
      }
      return domain.split('.')[0];
    } else {
      return null;
    }
  }

}
